import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

const SellerOrderList = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sortedOrders, setSortedOrders] = useState([]);
  const [approvingId, setApprovingId] = useState(null);
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rejectingId, setRejectingId] = useState(null);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [rejectionReason, setRejectionReason] = useState('');
  const [sellerMap, setSellerMap] = useState({});
  const [activeTab, setActiveTab] = useState("all");



  const itemsPerPage = 10;


  // ===================== FETCH ALL DATA =====================
  useEffect(() => {
    const fetchAll = async () => {
      try {
        setLoading(true); // optional but recommended

        // Categories
        const catRes = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_main_category"
        );
        if (catRes.data.status === "true" || catRes.data.status === true) {
          setCategories(catRes.data.row);
        }

        // Subcategories
        const subRes = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_main_subcategory"
        );
        if (subRes.data.status === "true" || subRes.data.status === true) {
          setSubcategories(subRes.data.row);
        }

        // Products
        const prodRes = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_create_product"
        );

        if (prodRes.data.status === "true" || prodRes.data.status === true) {
          const seqorder = prodRes.data.data.reverse(); 
          setOrders(seqorder);
          setSortedOrders(seqorder);
        } else {
          toast.error("Failed to fetch product list!");
        }

        // Sellers
const sellerRes = await axios.get(
  "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_seller_registration"
);

if (sellerRes.data.status === "true" || sellerRes.data.status === true) {
  const map = {};
  sellerRes.data.data.forEach((seller) => {
    map[String(seller.seller_id)] = seller.business_name;
  });
  setSellerMap(map);
}


      } catch (error) {
        console.error("Error fetching:", error);
        toast.error("Error fetching product list.");
      } finally {
        setLoading(false); // ✅ THIS FIXES THE ISSUE
      }
    };

    fetchAll();
  }, []);




  const openRejectModal = (productId) => {
    setSelectedProductId(productId);
    setShowRejectModal(true);
    setRejectionReason('');
  };

  // Close Reject Modal
  const closeRejectModal = () => {
    setShowRejectModal(false);
    setSelectedProductId(null);
    setRejectionReason('');
  };

  // Handle Rejection Submit
  const handleAdminRejection = async (e) => {
    e.preventDefault();

    if (!rejectionReason.trim()) {
      toast.error("Please provide a reason for rejection");
      return;
    }

    try {
      setRejectingId(selectedProductId);

      const formData = new FormData();
      formData.append("product_id", selectedProductId);
      formData.append("admin_approval", "rejected");
      formData.append("reason", rejectionReason);

      const response = await fetch(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/update_create_product",
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await response.json();
      console.log("Rejection API Response:", result);

      if (
        result.status === true ||
        result.status === "true" ||
        result.success === "1"
      ) {
        setOrders((prev) =>
          prev.map((item) =>
            item.product_id === selectedProductId
              ? { ...item, admin_approval: "rejected", reason: rejectionReason }
              : item
          )
        );

        setSortedOrders((prev) =>
          prev.map((item) =>
            item.product_id === selectedProductId
              ? { ...item, admin_approval: "rejected", reason: rejectionReason }
              : item
          )
        );

        toast.success("Product rejected successfully");
        closeRejectModal();
      } else {
        toast.error(result.message || "Rejection failed");
      }
    } catch (error) {
      console.error("Rejection error:", error);
      toast.error("Something went wrong");
    } finally {
      setRejectingId(null);
    }
  };


  const getApprovalBadge = (approval) => {
    if (approval === "approval" || approval === "approved" || approval === "yes") {
      return <span className="badge bg-success">Approved</span>;
    }
    if (approval === "rejected") {
      return <span className="badge bg-danger">Rejected</span>;
    }
    // if (approval === "rejected") {
    //   return <span className="badge bg-danger">Rejected</span>;
    // }
    if (approval === "Reapplied") {
      return <span className="badge bg-info">Reapplied</span>;
    }
    return <span className="badge bg-warning text-dark">Pending</span>;
  };



  // Convert Category ID → Name
  const getCategoryName = (id) => {
    const category = categories.find((c) => String(c.category_id) === String(id));
    return category ? category.category_name : "-";
  };

  // Convert Subcategory ID → Name
  const getSubCategoryName = (id) => {
    const sub = subcategories.find((s) => String(s.subcategory_id) === String(id));
    return sub ? sub.subcategory_name : "-";
  };


  const getOrderStatusBadge = (status) => {
    const value = status ? status.toLowerCase() : "pending";

    if (value === "in stock" || value === "available") {
      return "badge border border-success text-success px-2 py-1 fs-13";
    }
    if (value === "pending") {
      return "badge border border-secondary text-secondary px-2 py-1 fs-13";
    }
    return "badge border border-info text-info px-2 py-1 fs-13";
  };


  // ===================== STATUS HANDLING FIX =====================
  const getStatusUI = (statusValue) => {
    let text = "Out of Stock";
    let css = "bg-danger-subtle text-danger";

    if (statusValue === "In Stock") {
      text = "In Stock";
      css = "bg-success-subtle text-success";
    }
    if (statusValue === "Few Left") {
      text = "Few Left";
      css = "bg-warning-subtle text-warning";
    }

    return { text, css };
  };


  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handleAdminApproval = async (productId) => {
    const confirmApprove = window.confirm(
      "Are you sure you want to approve this seller's product?"
    );
    if (!confirmApprove) return;

    try {
      setApprovingId(productId);

      const formData = new FormData();
      formData.append("product_id", productId); // MUST MATCH BACKEND KEY
      formData.append("admin_approval", "approval");

      const response = await fetch(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/update_create_product",
        {
          method: "POST",
          body: formData, // ❗ NO headers
        }
      );

      const result = await response.json();
      console.log("Approval API Response:", result);

      if (
        result.status === true ||
        result.status === "true" ||
        result.success === "1"
      ) {
        setOrders((prev) =>
          prev.map((item) =>
            item.product_id === productId
              ? { ...item, admin_approval: "yes" }
              : item
          )
        );

        setSortedOrders((prev) =>
          prev.map((item) =>
            item.product_id === productId
              ? { ...item, admin_approval: "yes" }
              : item
          )
        );
      } else {
        alert(result.message || "Approval failed");
      }
    } catch (error) {
      console.error("Approval error:", error);
      alert("Something went wrong");
    } finally {
      setApprovingId(null);
    }
  };

  const handlePaidApproval = async (productId, status) => {
  const confirmMsg =
    status === "yes"
      ? "Approve paid promotion for this product?"
      : "Reject paid promotion for this product?";

  if (!window.confirm(confirmMsg)) return;

  try {
    const formData = new FormData();
    formData.append("product_id", productId);
    formData.append("paid_approval", status);

    const response = await fetch(
      "https://cyberathon.com/multivendor/index.php/Api/Master_controller/update_create_product",
      {
        method: "POST",
        body: formData,
      }
    );

    const result = await response.json();

    if (result.status === true || result.success === "1") {
      setOrders((prev) =>
        prev.map((item) =>
          item.product_id === productId
            ? { ...item, paid_approval: status }
            : item
        )
      );

      setSortedOrders((prev) =>
        prev.map((item) =>
          item.product_id === productId
            ? { ...item, paid_approval: status }
            : item
        )
      );

      toast.success(
        status === "yes"
          ? "Paid promotion approved"
          : "Paid promotion rejected"
      );
    } else {
      toast.error(result.message || "Action failed");
    }
  } catch (err) {
    console.error(err);
    toast.error("Something went wrong");
  }
};

// ✅ MOVE THIS UP
const sortByPriority = (list, priorityFn) => {
  return [...list].sort((a, b) => priorityFn(a) - priorityFn(b));
};

// ✅ NOW SAFE TO USE
const getTabOrders = () => {
  // ALL
  if (activeTab === "all") {
    return orders;
  }

  // PAID PROMOTION
  if (activeTab === "paid") {
    const paid = orders.filter(o => o.paid_promo === "yes");

    return sortByPriority(paid, (o) =>
      o.paid_approval === "yes" ? 1 : 0
    );
  }

  // APPROVED
  if (activeTab === "approved") {
    const approved = orders.filter(o =>
      !o.admin_approval ||
      o.admin_approval === "pending" ||
      o.admin_approval === "approval" ||
      o.admin_approval === "yes"
    );

    return sortByPriority(approved, (o) =>
      o.admin_approval === "approval" || o.admin_approval === "yes" ? 1 : 0
    );
  }

  // REJECTED
  if (activeTab === "rejected") {
    const rejected = orders.filter(o =>
      o.admin_approval === "rejected" ||
      o.admin_approval === "Reapplied"
    );

    return sortByPriority(rejected, (o) =>
      o.admin_approval === "rejected" ? 1 : 0
    );
  }

  return orders;
};


// 🔢 Pagination calculations
const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;

// 📌 Orders based on active tab
const tabOrders = getTabOrders();

// 📄 Current page data
const currentOrders = tabOrders.slice(
  indexOfFirstItem,
  indexOfLastItem
);

// 📑 Total pages
const totalPages = Math.ceil(tabOrders.length / itemsPerPage);





  const getPageNumbers = () => {
    const pages = [];

    let startPage = Math.max(1, currentPage - 1);
    let endPage = Math.min(totalPages, currentPage + 1);

    // Always show exactly 3 pages if possible
    if (currentPage === 1) {
      endPage = Math.min(3, totalPages);
    }

    if (currentPage === totalPages) {
      startPage = Math.max(totalPages - 2, 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    return pages;
  };

  const getPaidPromoBadge = (paidPromo, paidApproval) => {
  // Seller has NOT applied
  if (paidPromo !== "yes") {
    return <span className="badge bg-secondary">No Promotion</span>;
  }

  // Seller applied
  if (paidApproval === "yes") {
    return <span className="badge bg-primary">Paid Promotion Approved</span>;
  }

  if (paidApproval === "rejected") {
    return <span className="badge bg-danger">Promotion Rejected</span>;
  }

  return <span className="badge bg-warning text-dark">Promotion Pending</span>;
};


const getSellerName = (sellerId) => {
  return sellerMap[String(sellerId)] || "-";
};

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Seller Product List</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript: void(0);">Product</a>
                </li>
                <li className="breadcrumb-item active">Seller Product List</li>
              </ol>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-12">
            <div className="card">
      <div className="px-3 pt-3 d-flex align-items-center justify-content-between">

  {/* LEFT: Tabs */}
  <ul className="nav nav-tabs nav-tabs-custom gap-2 mb-0">

    {[
      { key: "all", label: "All Products" },
      { key: "paid", label: "Paid Promotion" },
      { key: "approved", label: "Approved" },
      { key: "rejected", label: "Rejected" }
    ].map(tab => (
      <li className="nav-item" key={tab.key}>
        <button
          className={`nav-link ${activeTab === tab.key ? "active" : ""}`}
          onClick={() => {
            setActiveTab(tab.key);
            setCurrentPage(1);
          }}
        >
          <h5 className="mb-0 fw-semibold">{tab.label}</h5>
        </button>
      </li>
    ))}

  </ul>

  {/* RIGHT: This Month Dropdown */}
  <div className="dropdown">
    <button
      className="btn btn-sm btn-outline-light rounded dropdown-toggle"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      This Month
    </button>

    <ul className="dropdown-menu dropdown-menu-end">
      <li><button className="dropdown-item">This Month</button></li>
      <li><button className="dropdown-item">Last Month</button></li>
      <li><button className="dropdown-item">Last 3 Months</button></li>
    </ul>
  </div>

</div>


              {/* <div className="d-flex card-header justify-content-between align-items-center">
                <div>
                </div>
              </div> */}

              <div className="card-body p-0">
                {loading ? (
                  <div className="text-center p-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : error ? (
                  <div className="alert alert-danger m-3" role="alert">
                    {error}
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="table align-middle mb-0 table-hover table-centered">
                      <thead className="bg-light-subtle">
                        <tr>
                          <th>Product ID</th>
                          <th>Seller</th>
                          <th>Product</th>

                          <th>Category</th>
                          <th>Sub-Category</th>
                          {/* <th>Current Price</th>
                          <th>Old Price</th>
                          <th>Stock</th>
                          <th>Rating</th> */}
                          <th>Created at</th>
                          <th>Promotion</th>
                          <th>Status</th>
                          <th>Admin Approval</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentOrders.length > 0 ? (
                          currentOrders.map((order) => {
                            const statusData = getStatusUI(order.status);

                            return (
                              <tr key={order.product_id}>
                                {/* Product ID */}
                                <td>#{order.product_id}</td>

                                {/* Seller */}
                                <td>{getSellerName(order.seller_id)}</td>


                                {/* Product Name */}
                                <td>{order.product_name || "-"}</td>

                                {/* Category */}
                                <td>{getCategoryName(order.category_id)}</td>

                                {/* Subcategory */}
                                <td>{getSubCategoryName(order.subcategory_id)}</td>

                                {/* <td>{order.current_price}</td>
                                <td>{order.old_price || "-"}</td> */}

                                {/* Stock */}
                                {/* <td>
                                  <span className="text-dark fw-medium">
                                    {order.stock} Items
                                  </span>
                                </td>

                                <td>{order.rating || "-"}</td> */}

                                {/* Created At */}
                                <td>{order.created_at || "-"}</td>

                                <td className="text-center">
  {getPaidPromoBadge(order.paid_promo, order.paid_approval)}
</td>


                                {/* ✅ STATUS (FIXED & WORKING) */}
                                <td>
                                  <span className={`badge ${statusData.css} py-1 px-2`}>
                                    {statusData.text}
                                  </span>
                                </td>

                                {/* Admin Approval */}
                                <td>{getApprovalBadge(order.admin_approval)}</td>

                                {/* Actions */}
                                <td>
  <div className="d-flex gap-2">

    <Link
                                        to={`/sellerorderlist-view/${order.product_id}`}
                                        className="btn btn-light btn-sm"
                                      >
                                        <i className="fa-solid fa-eye fs-18"></i>
                                      </Link>

    {/* Edit */}
    <Link
      to={`/product-edit/${order.product_id}`}
      className="btn btn-soft-primary btn-sm"
    >
      <i className="fa-solid fa-pencil fs-18"></i>
    </Link>

    {/* Delete */}
    <button className="btn btn-soft-danger btn-sm">
      <i className="fa-solid fa-trash fs-18"></i>
    </button>

    {/* Admin Actions */}
    <div className="dropdown">
      <button
        className="btn btn-sm btn-primary dropdown-toggle"
        type="button"
        data-bs-toggle="dropdown"
        disabled={approvingId === order.product_id || rejectingId === order.product_id}
      >
        Action
      </button>

      <ul className="dropdown-menu">

  {/* Admin Product Approval */}
  {order.admin_approval !== "yes" && (
    <li>
      <button
        className="dropdown-item text-success"
        onClick={() => handleAdminApproval(order.product_id)}
      >
        <i className="fa-solid fa-check me-2"></i>Approve Product
      </button>
    </li>
  )}

  <li>
    <button
      className="dropdown-item text-danger"
      onClick={() => openRejectModal(order.product_id)}
    >
      <i className="fa-solid fa-times me-2"></i>Reject Product
    </button>
  </li>

  <li><hr className="dropdown-divider" /></li>

  {/* PAID PROMOTION ACTIONS */}
  {order.paid_promo === "yes" && order.paid_approval !== "yes" && (
    <li>
      <button
        className="dropdown-item text-primary"
        onClick={() => handlePaidApproval(order.product_id, "yes")}
      >
        <i className="fa-solid fa-bullhorn me-2"></i>Approve Promotion
      </button>
    </li>
  )}

  {order.paid_promo === "yes" && (
    <li>
      <button
        className="dropdown-item text-danger"
        onClick={() => handlePaidApproval(order.product_id, "rejected")}
      >
        <i className="fa-solid fa-ban me-2"></i>Reject Promotion
      </button>
    </li>
  )}
</ul>

    </div>
  </div>
</td>

                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan="13" className="text-center py-4">
                              No orders found
                            </td>
                          </tr>
                        )}
                      </tbody>

                    </table>
                  </div>
                )}
              </div>

              <div className="card-footer border-top">
                <nav aria-label="Page navigation example">
                  <ul className="pagination justify-content-end mb-0">

                    {/* Previous */}
                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                      <button className="page-link" onClick={handlePrev}>
                        Previous
                      </button>
                    </li>

                    {/* Page Numbers (1,2,3 only) */}
                    {getPageNumbers().map((page) => (
                      <li
                        key={page}
                        className={`page-item ${currentPage === page ? "active" : ""}`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(page)}
                        >
                          {page}
                        </button>
                      </li>
                    ))}

                    {/* Next */}
                    <li
                      className={`page-item ${currentPage === totalPages ? "disabled" : ""
                        }`}
                    >
                      <button className="page-link" onClick={handleNext}>
                        Next
                      </button>
                    </li>

                  </ul>
                </nav>
              </div>

            </div>
          </div>
        </div>
      </div>

      {/* Rejection Modal */}
      {showRejectModal && (
        <div className="modal fade show d-block custom-modal-overlay" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <form onSubmit={handleAdminRejection}>
                <div className="modal-header">
                  <h5 className="modal-title fw-semibold">Reject Product</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={closeRejectModal}
                  ></button>
                </div>

                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label">
                      Reason for Rejection <span className="text-danger">*</span>
                    </label>
                    <textarea
                      className="form-control"
                      rows="4"
                      placeholder="Enter reason for rejecting this product..."
                      value={rejectionReason}
                      onChange={(e) => setRejectionReason(e.target.value)}
                      required
                    ></textarea>
                  </div>
                </div>

                <div className="modal-footer bg-light">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={closeRejectModal}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-danger"
                    disabled={rejectingId === selectedProductId}
                  >
                    {rejectingId === selectedProductId ? "Rejecting..." : "Reject Product"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              © Venton. Crafted by{" "}
              <iconify-icon
                icon="iconamoon:heart-duotone"
                className="fs-18 align-middle text-danger"
              />{" "}
              <a href="" className="fw-bold footer-text" target="_blank">
                Techzaa
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};


export default SellerOrderList;